export const AVATAR_PLACEHOLDER = "assets/placeholder/avatar.png";
